/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Sector_LabelInputs */

const en_company_profile_sector_label = /** @type {(inputs: Company_Profile_Sector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry`)
};

const de_company_profile_sector_label = /** @type {(inputs: Company_Profile_Sector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branche`)
};

/**
* | output |
* | --- |
* | "Industry" |
*
* @param {Company_Profile_Sector_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_sector_label = /** @type {((inputs?: Company_Profile_Sector_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Sector_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_sector_label(inputs)
	return en_company_profile_sector_label(inputs)
});